import { defineStore } from "pinia";
import { ref } from "vue";
import handleError from "@composables/handleError";
import useMyFetch from "@stores/useMyFetch";
import { useSurveyStore } from "@stores/survey/survey";

export const useVerbatimsStore = defineStore("verbatims", () => {
  const value = ref([]);
  const verbatimsExplore = ref([]);
  const chatMessages = ref([]);

  function getVerbatims(id) {
    const verbatim = verbatimsExplore.value.find((v) => v.questionId === id);
    return verbatim != null ? verbatim.verbatims : [];
  }
  async function setVerbatimsExplore(params) {
    try {
      const body = {
        filters: params.filters,
        target: params.target,
        show_translations: params.show_translations,
        page: params.page,
        page_size: params.page_size,
      };
      if (params.search) {
        body.search = params.search;
      }
      if (params.show_favorites) {
        body.show_favorites = params.show_favorites;
      }
      const response = await useMyFetch(`${useSurveyStore().questionApiPath(params.questionId)}/verbatims`, {
        headers: {
          "Content-Type": "application/json",
          signal: params.signal,
        },
      })
        .post(body)
        .json();
      const previous_verbatim = this.getVerbatims(params.questionId);
      this.set({
        questionId: params.questionId,
        data: response.data.value.data,
        verbatims: previous_verbatim,
      });
      return response;
    } catch (err) {
      if (err.code === "ERR_CANCELED") {
        return {
          data: {},
          status: "CANCELED",
        };
      } else {
        handleError(err);
      }
    }
  }

  function set(data) {
    const id = data.questionId;
    const verbatims = data.data;
    const previous_verbatim = data.verbatims;
    if (previous_verbatim.length === 0) {
      this.verbatimsExplore.push({
        questionId: id,
        verbatims: verbatims,
      });
    } else {
      const index = this.verbatimsExplore.findIndex((v) => v.questionId === id);
      this.verbatimsExplore[index].verbatims = verbatims;
    }
  }

  function addMessage(question, newMessage) {
    if (this.chatMessages.find((q) => question === q.question) != undefined) {
      this.chatMessages.find((q) => question === q.question).messages.push(newMessage);
    } else {
      this.chatMessages.push({ question: question, messages: [newMessage] });
    }
  }
  return {
    value,
    verbatimsExplore,
    chatMessages,
    getVerbatims,
    setVerbatimsExplore,
    set,
    addMessage,
  };
});
